import { combineSlices } from '@reduxjs/toolkit'

import { documentSummarySlice } from './documentSummary'
import { documentTypeSlice } from './documentTypes'
import { documentUserSlice } from './documentUsers'
import { documentInfoSlice } from './documentInfo'
import { emailAttachmentInfoSlice } from './emailAttachmentInfo'
import { documentProspectingSlice } from './documentProspecting'

export default combineSlices(documentSummarySlice, documentInfoSlice, documentTypeSlice, documentUserSlice, documentProspectingSlice, emailAttachmentInfoSlice)
